import { render, staticRenderFns } from "./link_area.vue?vue&type=template&id=6a73d4fc&scoped=true"
import script from "./link_area.vue?vue&type=script&lang=js"
export * from "./link_area.vue?vue&type=script&lang=js"
import style0 from "./link_area.vue?vue&type=style&index=0&id=6a73d4fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a73d4fc",
  null
  
)

export default component.exports